module.exports = __webpack_public_path__ + "static/img/7.34b0b16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/img/7.png
// module id = XR8l
// module chunks = 10